import type { CSSProperties, ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';
import type { LoadingErrorProps } from '../LoadingError';
import { LoadingError } from '../LoadingError';
import { LoadingIcon } from '../LoadingIcon';
import { PlaceHolder } from '../PlaceHolder';
import styles from './styles.module.css';

const classNames = {
  enter: styles.UnloadedMapEnter,
  enterActive: styles.UnloadedMapEnterActive,
  exit: styles.UnloadedMapExit,
  exitActive: styles.UnloadedMapExitActive,
  enterDone: styles.RemoveAfterTweak,
  appearDone: styles.RemoveAfterTweak,
};

export interface UnloadedMapProps {
  visible?: boolean;
  hasCenter?: boolean;
  hasError?: boolean;
  placeholder?: ReactNode;
  placeholderStyle?: Pick<CSSProperties, 'width' | 'height'>;
  onReload: LoadingErrorProps['onReload'];
}

export function UnloadedMap({
  visible,
  hasCenter,
  hasError,
  placeholder,
  placeholderStyle,
  onReload,
}: UnloadedMapProps): ReactNode {
  return (
    <CSSTransition unmountOnExit in={visible} classNames={classNames} timeout={1000}>
      {() => (
        <div className={styles.UnloadedMap}>
          <PlaceHolder placeholder={placeholder} style={placeholderStyle} />
          {hasError ? <LoadingError onReload={onReload} /> : hasCenter && <LoadingIcon />}
        </div>
      )}
    </CSSTransition>
  );
}
